// extracted by mini-css-extract-plugin
export default {"tcText":"AboutUs_tcText__dgGSP","aboutUsContainer":"AboutUs_aboutUsContainer__b1Gk9","containerText":"AboutUs_containerText__BP0Yf","containerIcon":"AboutUs_containerIcon__hUmJ3"};